export function open_deep_link(hookResult: {
  slides: { id: string; type: 'group' };
  tmpFile: string;
  token: string;
  iss: string;
}) {
  window.open(
    `iisy://${hookResult.slides.id}+group+${hookResult.tmpFile}+${hookResult.iss}+${hookResult.token}`,
    '_top'
  );
}
